import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import CookieBanner from '../CookieBanner';

const MainLayout = ({ children, user, onLogout, isLoading }) => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname, location.hash]);

  return (
    <div className="main-layout">
      <Header user={user} onLogout={onLogout} isLoading={isLoading} />
      <main className="main-content">{children}</main>
      <CookieBanner />
      <Footer />
    </div>
  );
};

// Default props to make user and onLogout optional
MainLayout.defaultProps = {
  user: null,
  onLogout: null,
  isLoading: false
};

export default MainLayout;
